
import { OnInit } from '@angular/core';
import { Component, ViewChild } from '@angular/core';
import { ModalDirective } from 'angular-bootstrap-md';
import { AlertService } from 'ngx-alerts';
import { CookieService } from 'ngx-cookie-service';
import { ChatLocalesModule } from '../../views/modelo/chatLocales/chatLocales';
import { LocalesModule } from '../../views/modelo/locales/locales.module';
import { MessageModule } from '../../views/modelo/message/message.module';
import { ChatService } from '../../views/servicios/chat.service';
import { LoginService } from '../../views/servicios/login.service';

import { navItems } from '../../_nav';
import { Subscription, interval } from 'rxjs';
import { Router } from '@angular/router';

@Component({
  selector: 'app-dashboard',
  templateUrl: './default-layout.component.html',
  providers: [ChatService]
})
export class DefaultLayoutComponent implements OnInit {
  private updateSubscription: Subscription;

  [x: string]: any;
  public sidebarMinimized = false;
  public navItems = navItems;
  @ViewChild('lgModal') public lgModal: ModalDirective;
  user: any;
  user_id: any;
  msg: any;
  input_message: any;
  show_message: any;
  numero: number
  messageText: String;
  messageArray: Array<{ user: String, message: String }> = [];
  messages = [];
  usuario: string;
  usuarios: string;
  local: string;
  id: string;
  habilitar: boolean;
  listaLocales: LocalesModule[];
  listaChatLocales: ChatLocalesModule[];
  listaCargar: ChatLocalesModule[];
  listaChatRespaldo: ChatLocalesModule[];
  mensaje: MessageModule;
  listMensaje: MessageModule[];

  constructor(
    private router: Router,
    private chatService: ChatService, private api: LoginService, private alertService: AlertService) {

    this.chatService.newUserJoined()
      .subscribe(data => this.messageArray.push(data));


    this.chatService.userLeftRoom()
      .subscribe(data => this.messageArray.push(data));

    this.chatService.newMessageReceived()
      .subscribe(data => this.messageArray.push(data));

  }




  chat() {


    this.api.historyChat(this.local).subscribe((
      data: MessageModule[]) => {
      this.listMensaje = data;

      this.listMensaje.forEach(element => {
        element.user = element.usuario;
        element.message = element.mensaje;
        element.hora = element.hora;

      });
      this.messageArray = this.listMensaje;

      this.usuario = localStorage.getItem('nombre');
      if (localStorage.getItem('rol') != 'MaxiPan') {
        this.local = localStorage.getItem('nombreLocal');
        this.listaChatLocales = []
      } else {
        this.listarChatLocales();
      }
      this.usuarios = this.usuario + "@" + this.local;
      this.room = this.local
      this.join();


      //console.log(this.listaLocales);
    },
      err => this.alertService.danger('Error no hay  conexion..')
    );


    this.lgModal.show();
  }



  newMessage: string;
  messageList: string[] = [];


  onChangeLocal($event: Event) {
    localStorage.setItem('id', this.id);
    // localStorage.setItem('nombreLocal', this.idLocal.toString());  

  }


  filtrarLocal(texto) {
    this.listaCargar = this.listaChatRespaldo;
    if (texto)
      this.listaChatLocales =
        this.listaCargar.filter((str) => {
          return str.local.toLowerCase().indexOf(texto.toLowerCase()) >= 0;
        });
    else
      this.listaChatLocales = this.listaChatRespaldo
  }

  join() {
    this.chatService.joinRoom({ user: this.usuarios, room: this.room });
  }

  leave() {
    this.chatService.leaveRoom({ user: this.usuarios, room: this.room });
  }

  changeMensaje(newValue) {
    this.messageText = newValue;
  }

  onKeypressMensaje(value: string) {
    this.messageText = value;
  }

  contarMensajes() {
    if (localStorage.getItem('rol') == 'MaxiPan') {
      this.api.contarMensajesAdministrador(localStorage.getItem('id_pais')).subscribe(
        data => (this.numero=data[0].cantidad), //This properly logs my data. How to extract `data` out of here and actually use it?
        error => { throw error },
        () => console.log("finished")
      );


    }else {
      this.api.contarMensajesLocal(this.local).subscribe(
        data => (this.numero=data[0].cantidad), //This properly logs my data. How to extract `data` out of here and actually use it?
        error => { throw error },
        () => console.log("finished")
      );

    }
    this.api.verficarMensajaMovil(localStorage.getItem('local'),localStorage.getItem('id_pais')).subscribe(
      data => { 
          if (data==1){
            this.router.navigate(['/dashboard'])
          }



       }, //This properly logs my data. How to extract `data` out of here and actually use it?
      error => { throw error },
      () => console.log("finished")
    );

  }

  sendMessage(mensaje) {
    this.usuario = localStorage.getItem('nombre');
    this.local = this.local;
    this.usuarios = this.usuario + "@" + this.local;
    this.room = this.local

    this.mensaje = new MessageModule();
    this.mensaje.usuario = this.usuario;
    this.mensaje.mensaje = this.messageText.toString();
    if (this.messageText.length>0){
    if ("CERRADO"==this.messageText.toString().toUpperCase().trim()){
      this.messageText = "";
      this.api.cerra_chat(this.local).subscribe(

        data => {
        
        },
  
        error => {
  
  
        }
  
      );
      
    }else{
    this.mensaje.sala = this.local;
    if (localStorage.getItem('rol') == 'MaxiPan') {
      this.mensaje.leer = 'S';
      this.mensaje.leer_local = 'N';
    } else {
      this.mensaje.leer = 'N';
      this.mensaje.leer_local = 'S';
    }
    this.api.guardar(this.mensaje).subscribe(

      data => {
        if (localStorage.getItem('rol') == 'MaxiPan') {
          this.listarChatLocales();
        }
        this.alertService.success("Se envio el mensaje");
      },

      error => {

        this.alertService.danger(error)

      }

    );

    this.chatService.sendMessage({ user: this.usuarios, room: this.room, message: this.messageText });
    this.messageText = "";

    }
  }
  }

  listarChatLocales() {
    this.chatService.listarLocales(localStorage.getItem("id_pais"))
      .subscribe((
        data: ChatLocalesModule[]) => {
        this.listaChatLocales = data;
        this.listaChatLocales.forEach(element => {
          if (Number.parseInt(element.mensaje) > 0) {
            element.color = "yellow"
          }
        });
        this.listaChatRespaldo = this.listaChatLocales;
        console.log(this.listaLocales);
      },
        err => this.alertService.danger('Error no hay  conexion..')
      );

  }

  listarLocales() {


    this.api.locales( localStorage.getItem("id_pais"))
      .subscribe((
        data: LocalesModule[]) => {
        this.listaLocales = data;
        this.usuario = localStorage.getItem("nombre");
        this.local = localStorage.getItem("nombreLocal");
        this.id = localStorage.getItem("id");
        if (localStorage.getItem("rol") == 'Administrador' || localStorage.getItem("rol") == 'Supermaxi') {
          this.habilitar = false;
        } else {
          this.habilitar = true;
        }
        console.log(this.listaLocales);
      },
        err => this.alertService.danger('Error no hay  conexion..')
      );

  }

  cargarChat(local) {
    this.usuario = localStorage.getItem('nombre');
    this.local = local;
    this.usuarios = this.usuario + "@" + this.local;
    this.room = this.local
    this.join();
    this.chatService.joinRoom({ user: this.usuarios, room: this.room });
    this.chat();
  }

  ngOnInit(): void {
    try {
      this.listarLocales();
      if (localStorage.getItem('rol') == 'MaxiPan') {
        this.listarChatLocales();
      }
      this.updateSubscription = interval(80000).subscribe(
        (val) => {  this.contarMensajes();
        }
      );
      this.chat();
      this.usuario = localStorage.getItem('nombre');
      this.local = localStorage.getItem('nombreLocal');
      this.usuarios = this.usuario + "@" + this.local;
      this.room = this.local
      this.join();
      this.chatService.joinRoom({ user: this.usuarios, room: this.room });

    } catch (e) {
      this.show_message = null
    }

  }


  toggleMinimize(e) {
    this.sidebarMinimized = e;
  }


}
